export default {
  scheme: 'Scheme',
  schemeName: 'Scheme name',
  description: 'Description',
  images: 'Images',
};
